export function safeUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url);
    if (u.protocol === "http:" || u.protocol === "https:") return u.toString();
    return "";
  } catch {
    return "";
  }
}

export function validateTraveler(t) {
  const errors = [];
  if (!t.title || t.title.trim().length < 2) errors.push("Titre: minimum 2 caractères.");
  if (t.photo?.url && !safeUrl(t.photo.url)) errors.push("Photo: URL invalide.");
  ["facebook", "instagram", "polarsteps"].forEach((k) => {
    if (t.links?.[k] && !safeUrl(t.links[k])) errors.push(`Lien ${k}: URL invalide.`);
  });
  return errors;
}

export function sanitizeTraveler(t) {
  return {
    _id: t._id || cryptoRandomId(),
    title: (t.title || "").trim(),
    subtitle: (t.subtitle || "").trim(),
    photo: {
      url: (t.photo?.url || "").trim(),
      alt: (t.photo?.alt || "").trim(),
    },
    links: {
      facebook: (t.links?.facebook || "").trim(),
      instagram: (t.links?.instagram || "").trim(),
      polarsteps: (t.links?.polarsteps || "").trim(),
    },
    createdAt: t.createdAt || new Date().toISOString(),
    updatedAt: t.updatedAt || new Date().toISOString(),
  };
}

export function cryptoRandomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return String(Date.now()) + "_" + Math.random().toString(16).slice(2);
}
